import { gql } from '@apollo/client';
import React from 'react';
import { NormalizePumoStyles } from '../NormalizePumoStyles';
import { RestrictPlatform } from '../RestrictPlatform';
import { PumoModuleSlide, PUMO_MODULE_SLIDE_FRAGMENT } from '../PumoModuleSlide';
import { MultiPumoModuleFragment } from '../../generated/types/MultiPumoModuleFragment';
import './MultiPumoModule.scss';
import { EDITORIAL_BG_COLORS, EditorialBgColor } from '../PumoModuleEditorialText';

interface Props {
  multiPumoModule: MultiPumoModuleFragment;
}
export const MULTI_PUMO_MODULE_FRAGMENT = gql`
  fragment MultiPumoModuleFragment on MultiPumoModule {
    bgColor
    platforms: platform
    units {
      ...PumoModuleSlideFragment
    }
    modelId
    moduleType
  }
  ${PUMO_MODULE_SLIDE_FRAGMENT}
`;

export const MultiPumoModule: React.FC<Props> = ({
  multiPumoModule: { units, bgColor, platforms, modelId, moduleType }
}) => {
  const backgroundColor = EDITORIAL_BG_COLORS[bgColor as EditorialBgColor];

  return (
    <RestrictPlatform platforms={platforms}>
      <NormalizePumoStyles
        className={`MultiPumoModule MultiPumoModule--${units.length}`}
        style={{ backgroundColor }}
        data-model-id={modelId}
        data-module-type={moduleType}
      >
        {units.map((slide, index) => (
          <PumoModuleSlide key={index} slide={slide} />
        ))}
      </NormalizePumoStyles>
    </RestrictPlatform>
  );
};
